/* eslint-disable no-restricted-imports */
// Components
export * from './components/TranslationProvider/TranslationProvider'
export { Trans } from 'react-i18next'

// Hooks
export { useTranslation } from 'react-i18next'
export { useLanguageState } from './hooks/useLanguageState'
export { useBrowserLanguage } from './hooks/useBrowserLanguage'

// i18n
export { default as i18n } from './i18n'

// Types
export { FlectoLanguages } from './types/FlectoLanguages'
